// extracted by mini-css-extract-plugin
module.exports = {"switch":"EditRecurringPaymentInformation_switch__2BWoZ"};